import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

export interface ICheckExamRequirementCodeType {
  isHisaType: boolean;
  isTse2Type: boolean;
  isTse1Type: boolean;
  isEntryExamType: boolean;
}

export const checkExamRequirementCodeType = (
  codeType: racehorse360.HorseExamRequirementTypeCode
): ICheckExamRequirementCodeType => ({
  isEntryExamType:
    codeType ===
    racehorse360.HorseExamRequirementTypeCode
      .HORSE_EXAM_REQUIREMENT_TYPE_CODE_ENTRY_EXAM,
  isTse1Type:
    codeType ===
    racehorse360.HorseExamRequirementTypeCode
      .HORSE_EXAM_REQUIREMENT_TYPE_CODE_TSE1,
  isTse2Type:
    codeType ===
    racehorse360.HorseExamRequirementTypeCode
      .HORSE_EXAM_REQUIREMENT_TYPE_CODE_TSE2,
  isHisaType:
    codeType ===
    racehorse360.HorseExamRequirementTypeCode
      .HORSE_EXAM_REQUIREMENT_TYPE_CODE_HISA
});
